'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));

function SVG(_ref) {
  var fill = _ref.fill,
      className = _ref.className;
  return /*#__PURE__*/React__default.createElement("svg", {
    "aria-labelledby": "aria",
    role: "img",
    viewBox: "0 0 476 124",
    className: className
  }, /*#__PURE__*/React__default.createElement("title", {
    id: "aria"
  }, "Loading..."), /*#__PURE__*/React__default.createElement("rect", {
    role: "presentation",
    x: "0",
    y: "0",
    width: "100%",
    height: "100%",
    clipPath: "url(#diff)",
    style: {
      fill: 'url("#animated-diff")'
    }
  }), /*#__PURE__*/React__default.createElement("defs", {
    role: "presentation"
  }, /*#__PURE__*/React__default.createElement("clipPath", {
    id: "diff"
  }, /*#__PURE__*/React__default.createElement("rect", {
    fill: fill,
    y: "56",
    width: "410",
    height: "10.7"
  }), /*#__PURE__*/React__default.createElement("rect", {
    fill: fill,
    y: "84.6",
    width: "380",
    height: "10.7"
  }), /*#__PURE__*/React__default.createElement("rect", {
    fill: fill,
    y: "113.3",
    width: "178",
    height: "10.7"
  }), /*#__PURE__*/React__default.createElement("rect", {
    fill: fill,
    width: "263.1",
    height: "27.6"
  })), /*#__PURE__*/React__default.createElement("linearGradient", {
    id: "animated-diff"
  }, /*#__PURE__*/React__default.createElement("stop", {
    offset: "0%",
    stopColor: "#273238",
    stopOpacity: "1"
  }, /*#__PURE__*/React__default.createElement("animate", {
    attributeName: "offset",
    values: "-2; -2; 1",
    keyTimes: "0; 0.25; 1",
    dur: "1.2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React__default.createElement("stop", {
    offset: "50%",
    stopColor: "#757e83",
    stopOpacity: "1"
  }, /*#__PURE__*/React__default.createElement("animate", {
    attributeName: "offset",
    values: "-1; -1; 2",
    keyTimes: "0; 0.25; 1",
    dur: "1.2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React__default.createElement("stop", {
    offset: "100%",
    stopColor: "#273238",
    stopOpacity: "1"
  }, /*#__PURE__*/React__default.createElement("animate", {
    attributeName: "offset",
    values: "0; 0; 3",
    keyTimes: "0; 0.25; 1",
    dur: "1.2s",
    repeatCount: "indefinite"
  })))));
}
SVG.propTypes = {
  /** Additional class name */
  className: PropTypes.string,
  fill: PropTypes.string
};
SVG.defaultProps = {
  fill: '#9ea5b'
};

module.exports = SVG;
